<!--  -->
<template>
  <div>
    <div :class="isMobile?'mlayout':'layout'">
      <span class="close" @click="close"><img src="@/assets/images/close2.png" alt=""></span>
      <iframe class="ebook" v-if="activeItem.mode" :src="activeItem.direction?`https://4dscene.4dage.com/wuhu/RuiJinMuseum/ebook/index.html?pages=${activeItem.sid}&mode=${activeItem.direction}`:`https://4dscene.4dage.com/wuhu/RuiJinMuseum/ebook/index.html?pages=${activeItem.sid}`" frameborder="0"></iframe>
      <template v-else>
        <div class="detail-container">
        <div v-if="!activeItem.link" class="top-imgs">
          <!-- <div class="spagination" slot="pagination"></div> -->
          <Swiper ref="detailImg" :options="swiperOption" :class="['swiperContainer',activeItem.images>1?'':'swiper-no-swiping']">
            <SwiperSlide class="swiper-slide" v-for="(item,i) in activeItem.images" :key="i"><img v-viewer="{title:false,navbar:false}"
                ref="viewer" :src="`${$imagesurl}/antiques/${activeItem.sid}/${i + 1}.JPG`" alt=""></SwiperSlide>

          </Swiper>
          <div class="icon left" v-if="activeItem.images>1"><img src="@/assets/images/left.png" alt=""></div>
          <div class="icon right" v-if="activeItem.images>1"><img src="@/assets/images/right.png" alt=""></div>
        </div>
        <div v-else class="top-iframe">
          <iframe :src="activeItem.link" frameborder="0"></iframe>
          <!-- <div class="showScreen" @click="fullscreen"><img src="@/assets/images/full-icon.png" alt=""></div> -->
        </div>
        <div class="bottom-info">
          <p class="title">{{activeItem.name}}</p>
          <p class="content">{{activeItem.intro}}</p>
        </div>
      </div>

      <div class="fullcontainer" v-show="isShow">
        <iframe :src="activeItem.link" frameborder="0"></iframe>
        <span class="hideScreen" @click="fullscreen"><img src="@/assets/images/smaller.png" alt=""></span>
      </div>
      </template>
      
    </div>
  </div>


</template>

<script>
  //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  //例如：import 《组件名称》 from '《组件路径》';
  import {
    Swiper,
    SwiperSlide
  } from 'vue-awesome-swiper';
  import "swiper/css/swiper.css";
  import browser from "@/utils/browser.js";
  export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
      Swiper,
      SwiperSlide
    },
    props: {
      activeItem: Object
    },
    data() {
      //这里存放数据

      return {
        isMobile: browser.mobile,
        isShow: false,
        curId: '',
        activeIdx: '',
        list: [],
        total: 0,
      };
    },
    //监听属性 类似于data概念
    computed: {

      swiperOption() {
        if (this.activeItem.images == '') {
          return {
            noSwiping: true,
          }
        } else if (this.activeItem.images.length == 1) {
          return {
            noSwiping: true,


          }
        } else return {
          autoplay: false,
          // watchSlidesProgress: true,
          // slidesPerView: "auto",
          // centeredSlides: true,
          // initialSlide: 1,
          navigation: {
            nextEl: '.right', //前进按钮的css选择器或HTML元素。
            prevEl: '.left',
          },
          // pagination: {
          //   el: ".spagination",
          //   type: "bullets",
          //   clickable: true
          // },
          on: {
            progress: function () {
              for (let i = 0; i < this.slides.length; i++) {
                var slide = this.slides.eq(i);
                var slideProgress = this.slides[i].progress;
                var modify = 1;
                if (Math.abs(slideProgress) > 1) {
                  modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
                }
                let translate = slideProgress * modify * 340 + "px";
                let scale = 1 - Math.abs(slideProgress) / 5;
                let zIndex = 999 - Math.abs(Math.round(10 * slideProgress));

                // let opacity = 1 - Math.min(Math.abs(slideProgress / 2), 1);

                slide.transform(
                  "translateX(" + translate + ") scale(" + scale + ")"
                );
                slide.css({
                  "zIndex": zIndex,
                  "opacity": 1,
                  "pointer-events": 'auto',

                });

                if (Math.abs(slideProgress) > 3) {
                  slide.css({
                    // "opacity":0,
                    "pointer-events": "none"
                  });
                }
              }
            },
          }

        };
      },

    },
    //监控data中的数据变化
    watch: {

    },
    //方法集合
    methods: {
      close() {
        this.$emit('closeDetail')
      },
      pageChange(flag) {
        var that = this;
        var curID = parseInt(this.$route.query.id);
        if (flag == 'next') {
          curID = parseInt(curID) + 1;
        } else {
          curID = parseInt(curID) - 1;
        }
        if (curID >= 0 && curID < this.total) {
          this.list.forEach(item => {
            if (item.id == curID) {
              that.$router.push({
                name: 'Detail',
                query: {
                  id: item.id,
                  name: item.name,
                  content: item.content,
                  link: item.link,
                  images: item.images,
                  audio: item.audio
                },
                params: {}
              });
            }
          });
        }
      },
      async getcurItem() {
        var tempId = this.$route.query.sid;
        let res = await this.$http({
          method: "get",
          url: `list.json`
        });
        this.total = res.list.length;
        this.list = res.list;
        this.activeItem = res.list.filter((item) => {
          return item.sid == tempId
        })[0];
      },
      closePage() {
        window.location.href = 'about:blank';
        window.close();
      },
      fullscreen() {
        this.isShow = !this.isShow;

      },
      prev() {
        this.$refs.detailImg.$swiper.slidePrev();
      },
      next() {
        this.$refs.detailImg.$swiper.slideNext();
      }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
      this.getcurItem()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      //this.detail =JSON.parse(this.$route.query.data);
      this.getcurItem()
      console.log(this.activeItem)
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
  }
</script>
<style lang='less' scoped>
  //@import url(); 引入公共css类
  .layout {
    width: 74vw;
    height: 78vh;
    background: rgba(219, 40, 40, 0.25);
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    overflow: hidden;
    border-radius: 10px 10px 0 0;
    .ebook {
      width: 100%;
      height:100%;
    }
    .close {
      position:absolute;
      display:block;
      width:24px;
      top:10px;
      right:10px;
      z-index:999;
    }
    .detail-container {
      position: relative;
      width: 100%;
      height: 100%;
      overflow: auto;
      .top-imgs {
        position: relative;
        width: 100%;
        height: 84%;
        margin: 0 auto;
        box-shadow: 0px 3px 6px 1px #000000;
        border-radius:4px;
        .icon {
          position:absolute;
          top:0;
          bottom:0;
          margin:auto;
          width:2vw;
          height:2vw;
          border-radius:50%;
          z-index:99;
          outline:none;
          &.swiper-button-disabled {
            opacity:0.5;
            pointer-events:none;
            cursor:not-allowed;
          }
          &.left {
            left:2vw;           
          }
          &.right {
            right:2vw;
          }
          img {
            width:100%;
          }
        }
        .swiperContainer {
          width:100%;
          height:100%;
        }
        .swiper-slide {
          max-width:100%;
          max-height:100%;
          height:100%;
          text-align:center;
          img {
            max-height:100%;
            max-width:100%;
            width:auto;
          }
        }
        .spagination {
          bottom: 0;
          width: 100%;
          text-align: center;
          position: absolute;
          z-index: 2;
        }




      }

      .top-iframe {
        position: relative;
        width: 100%;
        height: 84%;
        margin: 0 auto;
        overflow: hidden;
        box-shadow: 0px 3px 6px 1px #000000;

        iframe {
          display: block;
          width: 100%;
          height: 100%;
          margin: 0 auto;
        }

        .showScreen {
          position: absolute;
          z-index: 222;
          bottom: 10px;
          right: 20vw;
          width: 36px;

          /deep/ span {
            display: none;
          }
        }
      }

      .bottom-info {
        max-width: 48vw;
        margin: 0 auto;
        padding-top: 1vw;
        box-sizing: border-box;
        height: 16%;
        overflow: auto;

        p {
          font-size: 1vw;
          text-align: start;
          color: #333;
        }

        .title {
          font-size: 20px;
          color: #fff;
          margin-bottom: 14px;
          text-align: center;
          font-weight: bold;
        }

        .content {
          text-indent: 2em;
          font-size:14px;
          color:rgba(255,255,255,0.9);
          span {
            margin-right: 2em;
          }
        }
      }

      .page-icon {
        position: absolute;
        top: 14vw;
        width: 1vw;
        height: 1.77vw;
        border: none;
        outline: none;

        &.next {
          right: 7vw;
        }

        &.prev {
          left: 7vw;
        }

      }
    }
  }

  .fullcontainer {
    position: absolute;
    top: 0;
    z-index: 222222;
    width: 100%;
    height: 100%;

    iframe {
      width: 100%;
      height: 100%;
    }

    .hideScreen {
      position: absolute;
      right: 10px;
      bottom: 10px;
      width: 30px;
    }
  }



  .mlayout {
    position:fixed;
    top:0;
    bottom:0;
    left:0;
    right:0;
    margin:auto;
    width:90%;
    height:90%;
    border-radius:10px;
    background:rgba(219, 40, 40,0.25); 
    overflow: hidden;
    .ebook {
      width: 100%;
      height:100%;
    }
    .close {
      position:absolute;
      display:block;
      width:24px;
      top:10px;
      right:10px;
      z-index:999;
    }
    .detail-container {
      width: 89.6vw;
      height:100%;
      margin: 0 auto;
      .top-iframe {
        width:100%;
        height:84%;
        iframe {
          width:100%;
          height:100%;
        }
      }
      .top-imgs {
        width:100%;
        height: 70%;
        display: flex;
        justify-content: center;
        align-items: center;
        background-image: linear-gradient(360deg, #5d5a5a, #fffcfc);
        box-shadow: 0px 3px 6px 1px #000000;
        .swiper-slide {
          width: 100%;
        }
        .icon {
          position:absolute;
          bottom:0;
          margin:auto;
          width:6vw;
          height:6vw;
          top:29vh;
          bottom:auto;
          border-radius:50%;
          z-index:99;
          outline:none;
          &.swiper-button-disabled {
            opacity:0.5;
            pointer-events:none;
            cursor:not-allowed;
          }
          &.left {
            left:2vw;           
          }
          &.right {
            right:2vw;
          }
          img {
            width:100%;
          }
        
          
        }
      }
      .bottom-info {
        width: 100%;
        max-width:100%;
        margin:0 auto;
        padding-top: 4.7vw;
        box-sizing: border-box;
        color: #111110;
        .title {
          font-size: 16px;
          color: #fff;
          margin-bottom: 14px;
          text-align: center;
          font-weight: bold;
        }
        .content {
          text-indent: 2em;
          font-size:12px;
          color:rgba(255,255,255,0.9);
          span {
            margin-right: 2em;
          }
        }
      }
    }

  }

  
</style>
<style>
  .spagination .swiper-pagination-bullet {
    background: #666;
    margin: 0 5px;
  }

  .spagination .swiper-pagination-bullet-active {
    background: #b52223;
  }
</style>